import React from 'react';
import classNameBind from 'classnames/bind';
import styles from './LegendContent.module.css';

const bindClasses = classNameBind.bind(styles);

/* eslint-disable react/no-array-index-key */

const LegendContent = ({
  payload,
  framed,
  chartType,
  labelSeries,
  labelSegment = null,
  compareMode,
  compareDivider,
  maxHeight,
} = {}) => {
  const isPie = chartType === 'pie';

  return (
    <div
      className={bindClasses('legend-wrapper', { framed }, chartType)}
      style={maxHeight ? { maxHeight } : null}
      data-ppuc-id="Chart.LegendContent"
    >
      {
        labelSeries ? (
          <div className={bindClasses('legend-series', isPie ? 'bold' : 'inline')}>
            {labelSeries}
            {!isPie && ':'}
          </div>
        ) : null
      }
      {labelSegment !== null && (
        <div>
          <div className={bindClasses('segment-label', `lvl-${labelSegment.id}`)}>
            {labelSegment.name}
          </div>
        </div>
      )}
      {
        payload.map((entry, index) => ([
          compareDivider > 0
          && (index % compareDivider) === 0
          && compareMode.length > (index / compareDivider)
            ? (
              <div className={bindClasses('segment-label', `lvl-${index / compareDivider}`)} key={index}>{compareMode[index / compareDivider]}</div>
            ) : null,
          <div className={bindClasses('legend-entry')} key={`item-${index}`}>
            <div className={bindClasses('legend-icon')} style={{ backgroundColor: entry.payload?.color || entry.color }} />
            <div className={bindClasses('legend-label')}>{entry.value}</div>
          </div>,
        ]))
      }
    </div>
  );
};

LegendContent.defaultProps = {
  chartType: '',
  compareDivider: 0,
  compareMode: [],
  labelSegment: null,
  maxHeight: null,
};

export default LegendContent;
